




















































import { Component, Prop } from 'vue-property-decorator';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'GeneralLedgerSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    async beforeMount() {
        await GeneralLedgerAccountsModule.getGeneralLedgerAccountsForDialog();
    }

    get isDisabled() {
        const isGeneralLedgerAllowed = PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.GeneralLedger);
        return !isGeneralLedgerAllowed;
    }

    get generalLedgerOptions() {
        return GeneralLedgerAccountsModule.generalLedgerAccountsForDialog;
    }

    get loadingGeneralLedgerAccounts() {
        return GeneralLedgerAccountsModule.loadingGeneralLedgerAccounts;
    }

    get productVM() {
        if (this.isCreate) {
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

}
